/**
 * @generated SignedSource<<be633048a6a985341bc9747813398374>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortDirection = "ASC" | "DESC";
export type FlightFilters = {
  expired?: boolean | null;
  isUpdating?: boolean | null;
};
export type FlightSorting = {
  createdAt?: SortDirection | null;
  expired?: SortDirection | null;
  lastPriceChange?: SortDirection | null;
  lastSuccessfulUpdate?: SortDirection | null;
  priceLive?: SortDirection | null;
  provider?: SortDirection | null;
  updatedAt?: SortDirection | null;
};
export type FlightListRefetchQuery$variables = {
  after?: string | null;
  filters?: FlightFilters | null;
  first: number;
  search?: string | null;
  sort?: FlightSorting | null;
};
export type FlightListRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FlightList_data">;
};
export type FlightListRefetchQuery = {
  response: FlightListRefetchQuery$data;
  variables: FlightListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isFlightSegmentType"
  },
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "departDatetime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "departAirportCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "arrivalAirportCode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FlightListRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FlightList_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FlightListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "search",
            "variableName": "search"
          },
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          }
        ],
        "concreteType": "FlightConnection",
        "kind": "LinkedField",
        "name": "flights",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlightEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Flight",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "provider",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceLive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastPriceLive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastPriceChange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastPriceChangeDays",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightPrice",
                    "kind": "LinkedField",
                    "name": "lastSuccessfulUpdate",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expired",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletable",
                        "storageKey": null
                      }
                    ],
                    "type": "Entity",
                    "abstractKey": "__isEntity"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "forwardSegments",
                        "plural": true,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "returnSegments",
                        "plural": true,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "FlightType",
                    "abstractKey": "__isFlightType"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e19d4ae1752647719a118c1f9afc140",
    "id": null,
    "metadata": {},
    "name": "FlightListRefetchQuery",
    "operationKind": "query",
    "text": "query FlightListRefetchQuery(\n  $after: String\n  $filters: FlightFilters\n  $first: Int!\n  $search: String\n  $sort: FlightSorting\n) {\n  ...FlightList_data\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment FlightListLastPriceChange_flight on Flight {\n  lastPriceChange\n  lastPriceChangeDays\n  createdAt\n}\n\nfragment FlightListLastUpdate_flight on Flight {\n  lastSuccessfulUpdate {\n    createdAt\n    id\n  }\n}\n\nfragment FlightListPrice_flight on Flight {\n  priceLive\n  lastPriceLive\n}\n\nfragment FlightListProvider_flight on Flight {\n  provider\n}\n\nfragment FlightListRow_flight on Flight {\n  id\n  createdAt\n  provider\n  ...EntityTableRow_entity\n  ...FlightShortDetails_flight\n  ...FlightListPrice_flight\n  ...FlightListLastPriceChange_flight\n  ...FlightListLastUpdate_flight\n  ...FlightListProvider_flight\n  ...FlightStatus_flight\n}\n\nfragment FlightList_data on Query {\n  flights(first: $first, after: $after, filters: $filters, search: $search, sort: $sort) {\n    edges {\n      node {\n        id\n        ...FlightListRow_flight\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n}\n\nfragment FlightShortDetailsSegments_segments on FlightSegmentType {\n  __isFlightSegmentType: __typename\n  id\n  departDatetime\n  departAirportCode\n  arrivalAirportCode\n}\n\nfragment FlightShortDetails_flight on FlightType {\n  __isFlightType: __typename\n  id\n  forwardSegments {\n    __typename\n    ...FlightShortDetailsSegments_segments\n    id\n  }\n  returnSegments {\n    __typename\n    ...FlightShortDetailsSegments_segments\n    id\n  }\n}\n\nfragment FlightStatus_flight on Flight {\n  expired\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "b8e551291d465c34ff83602bdf5537c0";

export default node;
